import React, { createContext, useContext } from "react";
import { RadioGroupVariantProps } from "./RadioGroup.style";
import { RadioGroupProps } from "./RadioGroup";

interface RadioGroupContextType {
  variant?: RadioGroupVariantProps["variant"];
  variantOptionLabel?: RadioGroupProps["variantOptionLabel"];
}

const RadioGroupContext = createContext<RadioGroupContextType | undefined>(
  undefined
);

export const useRadioGroupContext = () => {
  const context = useContext(RadioGroupContext);
  if (!context) {
    throw new Error("Radio components must be used within a RadioGroup");
  }
  return context;
};

interface RadioGroupProviderProps {
  children: React.ReactNode;
  variant?: RadioGroupVariantProps["variant"];
  variantOptionLabel?: RadioGroupProps["variantOptionLabel"];
}

export const RadioGroupProvider: React.FC<RadioGroupProviderProps> = ({
  children,
  variant = "default",
  variantOptionLabel = "alphabet",
}) => {
  return (
    <RadioGroupContext.Provider value={{ variant, variantOptionLabel }}>
      {children}
    </RadioGroupContext.Provider>
  );
};
